import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vip",
  "use": "icon-vip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-vip\"><defs><style type=\"text/css\"></style></defs><path d=\"M995.84 398.336a51.0464 51.0464 0 0 0-41.472-34.816l-273.92-39.936-122.368-248.32c-8.704-17.408-26.624-28.672-46.08-28.672s-37.376 11.264-46.08 28.672L343.552 323.584l-273.92 39.936c-19.456 3.072-35.328 16.384-41.472 34.816-6.144 18.432-1.024 38.912 12.8 52.736l198.144 193.536-46.592 272.896c-3.072 19.456 4.608 38.4 20.48 50.176 8.704 6.656 19.456 9.728 30.208 9.728 8.192 0 16.384-2.048 24.064-6.144L512 842.24l245.248 129.024c17.408 9.216 38.4 7.68 53.76-4.096 15.872-11.264 23.552-30.72 20.48-50.176l-46.592-272.896L983.04 450.56c13.824-13.312 18.944-33.792 12.8-52.224z\" fill=\"\" p-id=\"33393\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/vip.svg
// module id = OyYz
// module chunks = 1